import { ConfirmModal } from "@components/index";
import AlertImg from "@assets/images/alert-triangle.svg";

export const EditMotorConfirmModal = ({
  show,
  onClickCancel,
  onClickConfirm,
}: {
  show: boolean;
  onClickCancel: () => void;
  onClickConfirm: () => void;
}) => (
  <ConfirmModal
    show={show}
    confirmButtonTitle="Yes"
    onClickCancel={onClickCancel}
    onClickConfirm={onClickConfirm}
  >
    <div className="flex flex-col items-center text-center">
      <img src={AlertImg} alt="Alert" className="h-12 w-12 md:h-14 md:w-14" />
      <div className="pt-4 text-300 text-black-70">
        You are about to override the system-calculated Private Use value. To
        prevent incorrect calculations, the associated Mileage log will need to
        be deleted. Do you wish to proceed?
      </div>
    </div>
  </ConfirmModal>
);
